import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseTeammate, RTeammate} from './teammateModel';

/*
 * Runtime type.
 */

const RSearchTeammatesDirty = t.readonly(
  t.type({
    limit: t.number,
    teammates: t.readonlyArray(RTeammate),
  }),
);

/*
 * Type.
 */

export interface SearchTeammatesModel extends t.TypeOf<typeof RSearchTeammatesDirty> {}
export const RSearchTeammates = t.clean<SearchTeammatesModel>(RSearchTeammatesDirty as any);

/*
 * IO methods.
 */

export function parseSearchTeammates(src: any): SearchTeammatesModel {
  return {
    limit: src.limit || 0,
    teammates: src.teammates && src.teammates.map((teammate: any) => parseTeammate(teammate)),
  };
}

/*
 * API type.
 */

export const ApiSearchTeammates = makeApiType('searchTeammates', RSearchTeammates, parseSearchTeammates);
